import React from 'react';
import { updateInvestorQualificationMutation } from '../../../apollo';
import InvestorQualificationForm from './InvestorQualificationForm';
import AccountForm from '../AccountForm';

const InvestorQualification = (props) => (
  <AccountForm
    title='Investor Qualification'
    Form={InvestorQualificationForm}
    mutation={updateInvestorQualificationMutation}
    {...props}
  />
);
export default InvestorQualification;



// WEBPACK FOOTER //
// ./src/components/Account/InvestorQualification/index.js